import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowRight, MapPin, Calendar, Home, Building2, CheckCircle } from 'lucide-react';

export const Projects = () => {
  const [filter, setFilter] = useState('all');

  const projects = [
    {
      id: 1,
      name: 'Résidence Romina',
      location: 'Luxembourg',
      type: '10 appartements',
      yearAcquired: '2017',
      yearCompleted: '2019',
      status: 'completed',
      image: 'https://customer-assets.emergentagent.com/job_36e39742-fbf9-436c-9759-46f0576965a5/artifacts/9io6iicw_IMG_2444.jpeg',
      partner: 'Société CORUM',
    },
    {
      id: 2,
      name: 'Résidence Oradour',
      location: 'Luxembourg',
      type: '6 logements',
      yearAcquired: '2018',
      yearCompleted: '2020',
      status: 'completed',
      image: 'https://customer-assets.emergentagent.com/job_36e39742-fbf9-436c-9759-46f0576965a5/artifacts/1916873a_IMG_2445.jpeg',
      partner: 'Société CORUM',
    },
    {
      id: 3,
      name: 'Résidence Luciano',
      location: 'Luxembourg',
      type: '8 logements',
      yearAcquired: null,
      yearCompleted: null,
      status: 'completed',
      image: 'https://customer-assets.emergentagent.com/job_36e39742-fbf9-436c-9759-46f0576965a5/artifacts/x5zl8dge_IMG_2442.jpeg',
      partner: 'Société CORUM',
    },
    {
      id: 4,
      name: 'Résidence Lorenzo',
      location: 'Luxembourg',
      type: '12 logements',
      yearAcquired: '2018',
      yearCompleted: '2022',
      status: 'completed',
      image: 'https://customer-assets.emergentagent.com/job_36e39742-fbf9-436c-9759-46f0576965a5/artifacts/w45w3eod_IMG_2443.jpeg',
      partner: 'Société CORUM',
    },
    {
      id: 5,
      name: 'Résidence Luna',
      location: 'Luxembourg',
      type: '10 appartements',
      yearAcquired: '2018',
      yearCompleted: '2023',
      status: 'completed',
      image: 'https://customer-assets.emergentagent.com/job_36e39742-fbf9-436c-9759-46f0576965a5/artifacts/vu9g7l06_IMG_2439.jpeg',
      partner: 'Société CORUM',
    },
    {
      id: 6,
      name: 'Résidence Frieden',
      location: 'Luxembourg',
      type: '6 logements',
      yearAcquired: '2019',
      yearCompleted: '2023',
      status: 'completed',
      image: 'https://customer-assets.emergentagent.com/job_36e39742-fbf9-436c-9759-46f0576965a5/artifacts/ct6rf5hg_IMG_2440.jpeg',
      partner: 'Société CORUM',
    },
    {
      id: 7,
      name: 'Résidence Schéva',
      location: 'Luxembourg',
      type: '5 appartements',
      yearAcquired: '2017',
      yearCompleted: '2019',
      status: 'completed',
      image: 'https://customer-assets.emergentagent.com/job_36e39742-fbf9-436c-9759-46f0576965a5/artifacts/hk98u36d_IMG_2441.jpeg',
      partner: 'Société CORUM',
    },
    {
      id: 8,
      name: 'Résidence Gemini',
      location: 'Luxembourg',
      type: '10 appartements',
      yearAcquired: '2018',
      yearCompleted: '2022',
      status: 'completed',
      image: 'https://customer-assets.emergentagent.com/job_36e39742-fbf9-436c-9759-46f0576965a5/artifacts/azelt3jp_IMG_2437.jpeg',
      partner: 'Société CORUM',
    },
    {
      id: 9,
      name: 'Maison Am Buch',
      location: 'Luxembourg',
      type: '6 maisons',
      yearAcquired: '2017',
      yearCompleted: '2019',
      status: 'completed',
      image: 'https://customer-assets.emergentagent.com/job_36e39742-fbf9-436c-9759-46f0576965a5/artifacts/4hwpgm5g_IMG_2436.jpeg',
      partner: 'Société CORUM',
    },
    {
      id: 10,
      name: 'Maison AM Park',
      location: 'Luxembourg',
      type: 'Maison individuelle',
      yearAcquired: '2013',
      yearCompleted: '2015',
      status: 'completed',
      image: 'https://customer-assets.emergentagent.com/job_36e39742-fbf9-436c-9759-46f0576965a5/artifacts/t288kcow_IMG_2434.jpeg',
      partner: 'Société CORUM',
    },
    {
      id: 11,
      name: 'Résidence Kalt',
      location: 'Luxembourg',
      type: '2 maisons individuelles',
      yearAcquired: '2017',
      yearCompleted: '2018',
      status: 'completed',
      image: 'https://customer-assets.emergentagent.com/job_36e39742-fbf9-436c-9759-46f0576965a5/artifacts/ckqwyoq6_IMG_2435.jpeg',
      partner: 'Société CORUM',
    },
    {
      id: 12,
      name: 'Maison Sandweiler',
      location: 'Luxembourg',
      type: '4 maisons',
      yearAcquired: '2018',
      yearCompleted: '2021',
      status: 'completed',
      image: 'https://customer-assets.emergentagent.com/job_36e39742-fbf9-436c-9759-46f0576965a5/artifacts/gf4ki9od_IMG_2438.jpeg',
      partner: 'Société CORUM',
    },
    {
      id: 13,
      name: 'Programme 24 logements - Collectifs',
      location: 'France',
      type: '19 logements collectifs',
      yearAcquired: null,
      yearCompleted: null,
      status: 'completed',
      image: 'https://customer-assets.emergentagent.com/job_36e39742-fbf9-436c-9759-46f0576965a5/artifacts/2a8fpt7y_IMG_2455.jpeg',
      partner: 'Thierry Valeri',
    },
    {
      id: 14,
      name: 'Programme 24 logements - Maisons',
      location: 'France',
      type: '4 maisons individuelles',
      yearAcquired: null,
      yearCompleted: null,
      status: 'completed',
      image: 'https://customer-assets.emergentagent.com/job_36e39742-fbf9-436c-9759-46f0576965a5/artifacts/ue8fuy64_IMG_2451.jpeg',
      partner: 'Thierry Valeri',
    },
    {
      id: 15,
      name: 'Programme 6 logements',
      location: 'France',
      type: '6 logements sur parking en sous-sol',
      yearAcquired: null,
      yearCompleted: null,
      status: 'completed',
      image: 'https://customer-assets.emergentagent.com/job_36e39742-fbf9-436c-9759-46f0576965a5/artifacts/kpbo9sai_IMG_2452.jpeg',
      partner: 'Thierry Valeri',
    },
    {
      id: 16,
      name: 'Programme 36 logements',
      location: 'France',
      type: '36 logements locatifs sociaux',
      yearAcquired: null,
      yearCompleted: null,
      status: 'completed',
      image: 'https://customer-assets.emergentagent.com/job_36e39742-fbf9-436c-9759-46f0576965a5/artifacts/spca1znh_IMG_2454.jpeg',
      partner: 'Thierry Valeri',
    },
    {
      id: 17,
      name: 'Programme 33 logements',
      location: 'France',
      type: '33 logements locatifs et sociaux',
      yearAcquired: null,
      yearCompleted: null,
      status: 'completed',
      image: 'https://customer-assets.emergentagent.com/job_36e39742-fbf9-436c-9759-46f0576965a5/artifacts/pgyfwwud_IMG_2453.jpeg',
      partner: 'Thierry Valeri',
    },
    {
      id: 18,
      name: 'Programme 8 maisons Kuntzig',
      location: 'Kuntzig, France',
      type: '8 maisons',
      yearAcquired: null,
      yearCompleted: null,
      status: 'completed',
      image: 'https://customer-assets.emergentagent.com/job_36e39742-fbf9-436c-9759-46f0576965a5/artifacts/81al9b0l_IMG_2450.jpeg',
      partner: 'Thierry Valeri',
    },
    {
      id: 19,
      name: 'Résidence Le Verger',
      location: 'Rosselange, France',
      type: '19 logements',
      yearAcquired: null,
      yearCompleted: 'En livraison',
      status: 'in-progress',
      image: 'https://customer-assets.emergentagent.com/job_36e39742-fbf9-436c-9759-46f0576965a5/artifacts/4t51n90g_IMG_2467.jpeg',
      partner: 'KAPPA - Bailleur 3F',
      statusLabel: 'En livraison',
    },
    {
      id: 20,
      name: 'Résidence Le Boisset',
      location: 'Les Essards, France',
      type: '20 logements + 7 maisons individuelles',
      yearAcquired: null,
      yearCompleted: null,
      status: 'in-progress',
      image: 'https://customer-assets.emergentagent.com/job_36e39742-fbf9-436c-9759-46f0576965a5/artifacts/3njgax7o_IMG_2463.jpeg',
      partner: 'KAPPA - Groupe 3F',
      featured: true,
      statusLabel: 'En construction',
    },
    {
      id: 21,
      name: 'Résidence Le Woigot',
      location: 'Briey, France',
      type: '55 logements',
      yearAcquired: null,
      yearCompleted: 'Attente GFA',
      status: 'in-progress',
      image: 'https://customer-assets.emergentagent.com/job_36e39742-fbf9-436c-9759-46f0576965a5/artifacts/ulszi5my_IMG_2462.jpeg',
      partner: 'KAPPA - Batigère et Présence Habitat',
      statusLabel: 'Prêt à construire',
    },
    {
      id: 22,
      name: 'Résidence La Boissière',
      location: 'Homecourt, France',
      type: '18 logements',
      yearAcquired: null,
      yearCompleted: 'Attente GFA',
      status: 'in-progress',
      image: 'https://customer-assets.emergentagent.com/job_36e39742-fbf9-436c-9759-46f0576965a5/artifacts/p0m4k3yf_IMG_2465.jpeg',
      partner: 'KAPPA - Villogia',
      statusLabel: 'Prêt à construire',
    },
    {
      id: 23,
      name: 'Résidence Le Chatillon',
      location: 'Liverdun, France',
      type: '21 logements locatifs',
      yearAcquired: null,
      yearCompleted: 'Attente GFA',
      status: 'in-progress',
      image: 'https://customer-assets.emergentagent.com/job_36e39742-fbf9-436c-9759-46f0576965a5/artifacts/sxr96vu5_IMG_2464.jpeg',
      partner: 'KAPPA - Groupe 3F',
      statusLabel: 'Prêt à construire',
    },
    {
      id: 24,
      name: 'Résidence Le Bawe',
      location: 'Jarny, France',
      type: '27 logements',
      yearAcquired: null,
      yearCompleted: null,
      status: 'in-progress',
      image: 'https://customer-assets.emergentagent.com/job_36e39742-fbf9-436c-9759-46f0576965a5/artifacts/jukhco2z_IMG_2461.jpeg',
      partner: 'KAPPA - Vivest',
      statusLabel: 'En développement',
    },
    {
      id: 25,
      name: 'Résidence Le Viaduc',
      location: 'Knutange, France',
      type: '18 logements',
      yearAcquired: null,
      yearCompleted: null,
      status: 'in-progress',
      image: 'https://customer-assets.emergentagent.com/job_36e39742-fbf9-436c-9759-46f0576965a5/artifacts/4km8dts1_IMG_2456.jpeg',
      partner: 'KAPPA - Groupe 3F',
      statusLabel: 'En développement',
    },
    {
      id: 26,
      name: 'Résidence Knutange 2',
      location: 'Knutange, France',
      type: '36 logements',
      yearAcquired: null,
      yearCompleted: null,
      status: 'in-progress',
      image: 'https://customer-assets.emergentagent.com/job_36e39742-fbf9-436c-9759-46f0576965a5/artifacts/qxjaqtoh_IMG_2458.jpeg',
      partner: 'KAPPA - Groupe 3F',
      statusLabel: 'En développement',
    },
    {
      id: 27,
      name: 'Résidence Knutange 3',
      location: 'Knutange, France',
      type: '13 logements',
      yearAcquired: null,
      yearCompleted: null,
      status: 'in-progress',
      image: 'https://customer-assets.emergentagent.com/job_36e39742-fbf9-436c-9759-46f0576965a5/artifacts/k6nytsq6_IMG_2459.jpeg',
      partner: 'KAPPA - Vivest',
      statusLabel: 'En développement',
    },
    {
      id: 28,
      name: 'Résidence Le Parc - Logements',
      location: 'Sin Le Noble, France',
      type: '20 logements',
      yearAcquired: null,
      yearCompleted: null,
      status: 'in-progress',
      image: 'https://customer-assets.emergentagent.com/job_36e39742-fbf9-436c-9759-46f0576965a5/artifacts/abfejohg_IMG_2460.jpeg',
      partner: 'KAPPA - Maison & Cités',
      statusLabel: 'En développement',
    },
    {
      id: 29,
      name: 'Résidence Le Parc - Maisons',
      location: 'Sin Le Noble, France',
      type: '21 maisons',
      yearAcquired: null,
      yearCompleted: null,
      status: 'in-progress',
      image: 'https://customer-assets.emergentagent.com/job_36e39742-fbf9-436c-9759-46f0576965a5/artifacts/4yqnduqr_IMG_2457.jpeg',
      partner: 'KAPPA - Maison & Cités',
      statusLabel: 'En développement',
    },
  ];

  const filteredProjects = filter === 'all' 
    ? projects 
    : projects.filter(p => p.status === filter);

  const featuredProject = projects.find(p => p.featured);

  return (
    <div data-testid="projects-page">
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 lg:pt-40 lg:pb-32 bg-[#F4F4F5]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <p className="text-[#F25F19] font-bold uppercase tracking-widest mb-4">Nos réalisations</p>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-[#0A0A0A] uppercase tracking-tighter leading-tight mb-6">
              Des projets<br />
              <span className="text-[#F25F19]">d'excellence</span>
            </h1>
            <p className="text-lg md:text-xl text-[#71717A] max-w-xl">
              Découvrez nos réalisations passées et en cours. Chaque projet témoigne 
              de notre engagement envers la qualité et l'innovation.
            </p>
          </div>
        </div>
      </section>

      {/* Featured Project */}
      {featuredProject && (
        <section data-testid="featured-project" className="py-20 lg:py-24 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div className="relative">
                <img
                  src={featuredProject.image}
                  alt={featuredProject.name}
                  className="rounded-sm w-full"
                />
                <div className="absolute top-4 left-4 bg-[#F25F19] text-white px-4 py-2 rounded-sm font-bold uppercase text-sm">
                  Chantier en cours
                </div>
              </div>
              <div>
                <p className="text-[#F25F19] font-bold uppercase tracking-widest mb-4">Projet phare</p>
                <h2 className="text-3xl sm:text-4xl font-extrabold tracking-tighter mb-4">
                  {featuredProject.name}
                </h2>
                <p className="text-[#71717A] text-lg mb-6">
                  Notre programme en cours de réalisation : {featuredProject.units} destinés 
                  au logement social en partenariat avec {featuredProject.partner}.
                </p>
                
                <div className="grid grid-cols-2 gap-4 mb-8">
                  <div className="flex items-center gap-3">
                    <MapPin className="w-5 h-5 text-[#F25F19]" />
                    <span className="text-[#71717A]">{featuredProject.location}</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <Calendar className="w-5 h-5 text-[#F25F19]" />
                    <span className="text-[#71717A]">Livraison {featuredProject.yearCompleted}</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <Home className="w-5 h-5 text-[#F25F19]" />
                    <span className="text-[#71717A]">{featuredProject.units}</span>
                  </div>
                  <div className="flex items-center gap-3">
                    <Building2 className="w-5 h-5 text-[#F25F19]" />
                    <span className="text-[#71717A]">{featuredProject.partner}</span>
                  </div>
                </div>

                <div className="bg-[#F4F4F5] p-4 rounded-sm flex items-center gap-3 mb-6">
                  <CheckCircle className="w-6 h-6 text-[#F25F19]" />
                  <span className="font-medium">GFA obtenu - Chantier en cours</span>
                </div>

                <Link to="/contact">
                  <Button
                    className="bg-[#F25F19] hover:bg-[#CC480B] text-white font-bold uppercase tracking-wide px-6 py-3 rounded-sm"
                  >
                    En savoir plus
                    <ArrowRight className="ml-2 w-5 h-5" />
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Filter & Projects Grid */}
      <section data-testid="projects-grid" className="py-20 lg:py-32 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Filter */}
          <div className="flex flex-wrap justify-center gap-4 mb-12">
            {[
              { value: 'all', label: 'Tous les projets' },
              { value: 'completed', label: 'Réalisés' },
              { value: 'in-progress', label: 'En cours' },
            ].map((item) => (
              <button
                key={item.value}
                onClick={() => setFilter(item.value)}
                className={`px-6 py-3 font-bold uppercase tracking-wide text-sm rounded-sm transition-all ${
                  filter === item.value
                    ? 'bg-[#F25F19] text-white'
                    : 'bg-white text-[#0A0A0A] hover:bg-[#0A0A0A] hover:text-white'
                }`}
              >
                {item.label}
              </button>
            ))}
          </div>

          {/* Projects Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredProjects.map((project) => (
              <div
                key={project.id}
                className="project-card bg-white rounded-sm overflow-hidden group"
              >
                <div className="aspect-[4/3] overflow-hidden relative">
                  <img
                    src={project.image}
                    alt={project.name}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className={`absolute top-4 right-4 px-3 py-1 rounded-sm text-xs font-bold uppercase ${
                    project.status === 'completed' 
                      ? 'bg-[#0A0A0A] text-white' 
                      : 'bg-[#F25F19] text-white'
                  }`}>
                    {project.status === 'completed' ? 'Réalisé' : 'En cours'}
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold tracking-tight mb-3 text-[#0A0A0A]">{project.name}</h3>
                  <div className="space-y-1 text-sm text-[#71717A]">
                    <p><span className="font-medium text-[#0A0A0A]">Type de bien :</span> {project.type}</p>
                    {project.yearAcquired && (
                      <p><span className="font-medium text-[#0A0A0A]">Date d'acquisition :</span> {project.yearAcquired}</p>
                    )}
                    {project.yearCompleted && (
                      <p><span className="font-medium text-[#0A0A0A]">Date d'achèvement :</span> {project.yearCompleted}</p>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-16 bg-[#F4F4F5] border-y border-[#E4E4E7]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div>
              <p className="stat-number">200+</p>
              <p className="text-[#71717A] mt-2">Logements livrés</p>
            </div>
            <div>
              <p className="stat-number">29</p>
              <p className="text-[#71717A] mt-2">Programmes réalisés</p>
            </div>
            <div>
              <p className="stat-number">100%</p>
              <p className="text-[#71717A] mt-2">Projets livrés dans les délais</p>
            </div>
            <div>
              <p className="stat-number">3</p>
              <p className="text-[#71717A] mt-2">Partenaires majeurs</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 lg:py-24 bg-[#0A0A0A]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white tracking-tighter mb-6">
            Un projet à réaliser ?
          </h2>
          <p className="text-white/70 text-lg max-w-2xl mx-auto mb-10">
            Partagez-nous votre projet et bénéficiez de notre expertise pour le concrétiser.
          </p>
          <Link to="/contact">
            <Button
              data-testid="cta-contact-btn"
              className="bg-[#F25F19] hover:bg-[#CC480B] text-white font-bold uppercase tracking-wide px-8 py-6 text-base rounded-sm"
            >
              Nous contacter
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Projects;
